import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';

export const AppRoutes: Routes = [

  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './components/auth/auth.module#AuthModule'
      }
    ]
  },
  {
    path: '',
    component: AppBlankComponent,
    canActivate: [NoAuthGuard],
    children: [
      {
        path: '',
        loadChildren: './components/non-auth/non-auth.module#NonAuthModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'authentication/404'
  }
];
